import React from "react";
import PropTypes from 'prop-types';
import { Translate } from "../Translator";

const DatasourceGoogleMapsLIVE = (props) => {

    props.OnSetReady(true)
    
    return (<div>{Translate("No settings are required. Click Next to continue")}</div>)

}

DatasourceGoogleMapsLIVE.propTypes = {
    SecurityToken: PropTypes.string,
    DatasourceData: PropTypes.object,
    IntegrationSettings: PropTypes.object,
    OnSetReady: PropTypes.func
}   

export default DatasourceGoogleMapsLIVE